import { Paper } from "@mantine/core";

const MantinePaper = (props: any) => {
    const { shadow, style, children, className, p } = props;
    return (
        <Paper
            shadow={shadow}
            className={className}
            p={p}
            style={style}
        >
            {children}
        </Paper>
    );
};

export default MantinePaper;